module.exports = __webpack_public_path__ + "img/guangao02.37167928.jpg";